import Head from "next/head";

const RichSearch = ({ data }: { data: object }) => {
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  );
};

export default RichSearch;
